module.exports = __webpack_public_path__ + "img/marker_four_blue2.0a2a42e3.png";